module.exports = __webpack_public_path__ + "img/portfolio-guide-modal-illustration-en1.7cd51a4.png";